export default __webpack_public_path__ + "static/media/ambient-bright-orange-pink.418b3d68.jpg";